import * as R from 'ramda';


export default function BulkDeleteRisksDialogController(
  $rootScope,
  $scope,
  $q,
  ssDialogService,
  alerts,
  loaderService,
  assetDataService,
  bulkDeleteRisksConfirmDialog
) {
  const vm = this;
  vm.deleteIsSelected = false;
  vm.hasData = true;
  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleBulkDeleteDialogClick = _handleBulkDeleteDialogClick;
  vm.handleSelectAll = _handleSelectAll;
  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
    $scope.$on('selectBulkRiskChange', () => {
      _handleSelectAssetChange();
    });
  }

  function _handleBulkDeleteDialogClick($event) {
    const _ids = [];
    R.forEach(
      (item) => {
        if (item.isBulkDelete === true) {
          _ids.push(item.customerRiskId);
        }
      },
      vm.riskType.customerRisks
    );
    ssDialogService.dialogs.riskAdmin.bulkDeleteRisksConfirmDialog = ssDialogService.alert(
      bulkDeleteRisksConfirmDialog.getOptions($event, {
        risks: _ids,
        updateCallBack: _broadcastEvents,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.riskAdmin.bulkDeleteRisksConfirmDialog);
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.riskAdmin.bulkDeleteRisksDialog);
  }

  function _handleSelectAll() {
    R.forEach(
      (risk) => {
        risk.isBulkDelete = vm.selectAll;
        // if (!vm.selectAll) {
        vm.deleteIsSelected = vm.selectAll;
        // }
      },
      vm.riskType.customerRisks
    );
  }

  function _handleSelectAssetChange() {
    const selectedIds = [];
    R.forEach((item) => {
      if (item.isBulkDelete === true) {
        selectedIds.push(item.customerRiskId);
      }
    }, vm.riskType.customerRisks);
    vm.deleteIsSelected = selectedIds.length > 0;
    vm.selectAll = selectedIds.length === vm.riskType.customerRisks.length;
  }

  /** ************************************************
   * Private Functions
   */
  function _broadcastEvents() {
    $rootScope.$broadcast('refreshRiskType', { riskType: vm.riskType });
  }
}

BulkDeleteRisksDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'ssDialogService',
  'alerts',
  'loaderService',
  'assetDataService',
  'bulkDeleteRisksConfirmDialog',
];
